module.exports = __webpack_public_path__ + "static/microsoft-6e21061ba86ea316ab8124f6992319a7.svg";